export const setTestEnvironmentFlag = (testFeatureAccess) => {
  if (testFeatureAccess !== false) {
    localStorage.setItem('testFeatureAccess', testFeatureAccess);
  }
};

export const isFeatureEnabledForTestEnv = (chieftainFeatureFlag) =>
  localStorage.getItem('testFeatureAccess') === 'true' || chieftainFeatureFlag;
